const galleryData = [
  {
    file: "rainbow-faroes.JPG",
    category: "Nature",
    location: "Faroe Islands",
    coordinates: { lat: 62.0, lng: -6.78 },
    date: "2020",
  },
  {
    file: "boxhill-view.JPG",
    category: "Nature",
    location: "Box Hill, Surrey, UK",
    coordinates: { lat: 51.2497, lng: -0.3266 },
    date: "2019",
  },
  {
    file: "butterfly-montreal.JPG",
    category: "Nature",
    location: "Jardin botanique de Montréal, Canada",
    coordinates: { lat: 45.5583, lng: -73.5658 },
    date: "2019",
  },
  {
    file: "waterfall-faroes.JPG",
    category: "Nature",
    location: "Faroe Islands",
    coordinates: { lat: 62.0, lng: -6.78 },
    date: "2019",
  },
  {
    file: "sunset-brixton.JPG",
    category: "Nature",
    location: "Brixton, London, UK",
    coordinates: { lat: 51.4613, lng: -0.1156 },
    date: "2019",
  },
  {
    file: "cuba-view.JPG",
    category: "Urban",
    location: "Havana, Cuba",
    coordinates: { lat: 23.1136, lng: -82.3666 },
    date: "2019",
  },
  {
    file: "parakeet-hernehill.jpeg",
    category: "Animals",
    location: "Herne Hill, London, UK",
    coordinates: { lat: 51.4533, lng: -0.1017 },
    date: "2026",
  },
  {
    file: "inflight.jpeg",
    category: "Animals",
    location: "Brockwell Park, London, UK",
    coordinates: { lat: 51.4508, lng: -0.1091 },
    date: "2026",
  },
  {
    file: "sunset-field.jpeg",
    category: "Nature",
    location: "Wiltshire, UK",
    coordinates: { lat: 51.349, lng: -1.916 },
    date: "2022",
  },
  {
    file: "osborne.jpeg",
    category: "Animals",
    location: "Merton, UK",
    coordinates: { lat: 51.4116, lng: -0.1843 },
    date: "2026",
  },
  {
    file: "bee-brockwell.jpeg",
    category: "Nature",
    location: "Brockwell Park, London, UK",
    coordinates: { lat: 51.4533, lng: -0.1067 },
    date: "2026",
  },
  {
    file: "chief.jpeg",
    category: "Animal",
    location: "Mitcham, UK",
    coordinates: { lat: 51.4009, lng: -0.1786 },
    date: "2026",
  },
  {
    file: "moon.jpeg",
    category: "Nature",
    location: "Tulse Hill, London, UK",
    coordinates: { lat: 51.4426, lng: -0.1118 },
    date: "2020",
  },
  {
    file: "cuba-rooftops.jpeg",
    category: "Urban",
    location: "Havana, Cuba",
    coordinates: { lat: 23.1136, lng: -82.3666 },
    date: "2019",
  },
  {
    file: "monestry-malta.jpeg",
    category: "Objects",
    location:
      "Mysterium Fidei Museum St Catherine's Monastery and Secret Garden, Malta",
    coordinates: { lat: 35.8978, lng: 14.5125 },
    date: "2026",
  },
  {
    file: "statue-malta.jpeg",
    category: "Animals",
    location: "Valletta, Malta",
    coordinates: { lat: 35.8989, lng: 14.5141 },
    date: "2026",
  },
  {
    file: "sorrento-harbour.jpeg",
    category: "Travel",
    location: "Sorrento, Italy",
    coordinates: { lat: 40.6281, lng: 14.3758 },
    date: "2019",
  },
  {
    file: "mevagissey-harbour.jpeg",
    category: "Travel",
    location: "Mevagissey, Cornwall, UK",
    coordinates: { lat: 50.2681, lng: -4.7855 },
    date: "2020",
  },
  {
    file: "tower-birds-brockwell.jpeg",
    category: "Animals",
    location: "Brockwell Park, London, UK",
    coordinates: { lat: 51.4533, lng: -0.1067 },
    date: "2026",
  },
];

export default galleryData;
